
export class CheckPermissionGroupName {
    permissionName: string = '';
    permissionId?: number;
    isNotification?: boolean;
}